<div id="academy-course" class="page-layout simple left-sidebar inner-scroll">

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT -->
        <div id="course-content" class="content">
            <!-- ------contenido------ -->
            <div class="page-layout carded fullwidth inner-scroll cursoStep">
                <!-- TOP BACKGROUND -->
                <div class="top-bg"></div>
                <!-- CENTER -->
                <div class="center">
                    <!-- CONTENT HEADER -->
                    <div class="header p-24" fxLayout="row" fxLayoutAlign="start center">
                        <h2 class="m-0">{{ 'WIZARD.TITULO' | translate}} </h2>
                    </div>
                    <!-- CONTENT CARD -->
                    <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                        <!-- CONTENT TOOLBAR -->
                        <div class="toolbar primary px-24 py-8">
                            <span>{{ 'WIZARD.DESCRIPCION' | translate}}</span>
                        </div>
                        <!-- CONTENT -->
                        <div class="content" fusePerfectScrollbar>
                            <!--Cargando-->
                            <ng-container *ngIf="cargandoInformacion">
                                <div fxLayout="column" fxLayoutAlign="space-between center" syle="margin-top: 25px">
                                    <br>
                                    <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                                    <h1>Cargando</h1>
                                </div>
                            </ng-container>
                            <!--Finalizo de cargar información-->
                            <ng-container *ngIf="!cargandoInformacion">


                                <div class="course-step-content p-20">
                                    <ng-container *ngIf="Nivel1">
                                        <div fxLayout="column" fxLayoutAlign="space-around stretch" style="background: transparent !important;">
                                            <mat-form-field>
                                                <mat-label>{{'WIZARD.FILTERCT' | translate}}</mat-label>
                                                <mat-select>
                                                    <mat-option *ngFor="let ct of centrosTrabajo" (click)="filtroCT(ct.centro.id_CT,ct.centro._id,ct.centro.nombre_CT);">
                                                        {{ct.centro.nombre_CT}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div fxLayout="column" fxLayoutAlign="space-around stretch" style="background: transparent !important;" *ngIf="carga_filtro">
                                            <h2 style="text-align: center;">{{nombreCT_tpm}}</h2>
                                        </div>
                                        <div fxLayout="column" fxLayoutAlign="space-around stretch" *ngIf="carga_filtro">
                                            <button mat-button (click)="copyMessage()">{{'WIZARD.CLAVE' | translate}}</button>

                                            <!--<button mat-icon-button aria-label="">
                                                <mat-icon matTooltip="Enalce" style="font-size: 50px; color: #F50000;">content_copy</mat-icon>
                                            </button>-->
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="!Nivel1">
                                        <div fxLayout="column" fxLayoutAlign="space-around stretch" style="background: transparent !important; padding-bottom: 20px;">
                                            <h2>Para que los nuevos colaboradores realicen la encuesta por favor haga clic en el elace de abajo</h2>
                                            <h3 style="font-weight:bold; text-align: center;"><a href="{{ urlAutoLogin}}" target="_blank">Clic aquí</a></h3>
                                        </div>
                                    </ng-container>
                                    <ng-container>
                                        <div fxLayout="column" fxLayoutAlign="space-around stretch" style="background: transparent !important;">
                                            <mat-form-field appearance="outline" style="background: transparent !important;">
                                                <mat-label class="buscador" style="background: transparent !important;">{{'WIZARD.FILTER' | translate}}</mat-label>
                                                <input matInput style="background: transparent !important;" class="buscadorInput" (keyup)="applyFilter($event)">
                                                <mat-icon matSuffix class="disabled-text">search</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <!--PARTE SI NO HAY INFORMACIÓN EN LA TABLA-->
                                        <ng-container *ngIf="!encontro_informacion">
                                            <div fxLayout="column" fxLayoutAlign="space-around stretch" style="background: transparent !important; padding-bottom: 20px; text-align: center; font-weight: bold;">
                                                <h2>Aún no hay colaboradores registrados</h2>
                                            </div>
                                        </ng-container>
                                        <!--PARTE SI HAY INFORMACIÓN EN LA TABLA-->
                                        <ng-container *ngIf="encontro_informacion">
                                            <div fxLayout="column" fxLayoutAlign="space-around stretch" style="background: transparent !important;">
                                                <table mat-table [dataSource]="dataSource" class="mat-elevation-z3 p-20" fxFlex="100">

                                                    <ng-container matColumnDef="name">
                                                        <th mat-header-cell *matHeaderCellDef class="tableInput"> Nombre </th>
                                                        <td mat-cell *matCellDef="let element" class="tableInput"> {{element.nombre}} </td>
                                                    </ng-container>

                                                    <ng-container matColumnDef="tel">
                                                        <th mat-header-cell *matHeaderCellDef class="tableInput"> Telefono </th>
                                                        <td mat-cell *matCellDef="let element" class="tableInput"> {{element.telefono}} </td>
                                                    </ng-container>


                                                    <ng-container matColumnDef="correo">
                                                        <th mat-header-cell *matHeaderCellDef class="tableInput"> Correo </th>
                                                        <td mat-cell *matCellDef="let element" class="tableInput"> {{element.correo}} </td>
                                                    </ng-container>


                                                    <ng-container matColumnDef="clave">
                                                        <th mat-header-cell *matHeaderCellDef class="tableInput"> Clave </th>
                                                        <td mat-cell *matCellDef="let element" class="tableInput"> {{element.clave}} </td>

                                                    </ng-container>


                                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                                </table>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                </div>



                            </ng-container>


                        </div>

                    </div>
                </div>
            </div>
            <!-- ------contenido------ -->
        </div>
        <!-- / CONTENT -->
    </div>
    <!-- / CENTER -->
</div>